import {Component, effect, inject} from '@angular/core';
import {IFilter, INITIAL_STATE_TOKEN} from 'frontier/nucleus';
import {SharedGridOptions, TableControlComponent, TableControlModule, ToolbarStore} from 'frontier/browserkit';
import {GridOptions} from 'ag-grid-community';
import AppControlGuids from '../../../../../api/ControlGuids';

@Component({
  selector: 'app-tariff-groups',
  templateUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
  providers: [{provide: INITIAL_STATE_TOKEN, useValue: {filter: null}}],
})
export class TariffGroupsComponent extends TableControlComponent {
  private toolbarStore: ToolbarStore = inject(ToolbarStore);
  override GUID: string = AppControlGuids.TItemGroupView;
  override tableName: string = 'Tarifgruppen';

  override gridOptions: GridOptions = {
    ...SharedGridOptions,
    rowSelection: 'multiple',
  };

  constructor() {
    super();
    effect(() => {
      const toolbarFilterDto: IFilter = this.toolbarStore.toolbarFilterDto();
      if (toolbarFilterDto) {
        this.patchFilter({...toolbarFilterDto});
      }
    }, {allowSignalWrites: true});
  }
}
